import { render, staticRenderFns } from "./LocationsManagement.vue?vue&type=template&id=6232ed38&scoped=true"
import script from "./LocationsManagement.vue?vue&type=script&lang=js"
export * from "./LocationsManagement.vue?vue&type=script&lang=js"
import style0 from "./LocationsManagement.vue?vue&type=style&index=0&id=6232ed38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232ed38",
  null
  
)

export default component.exports